<template>
    <section class="main promotions">

        <h1 class="dashboard"><span class="breadcrumb" @click="clearFilters()">Campaign Reports</span>
            <i v-if="push_pack_id" class="fas fa-chevron-right"></i>
            <span v-if="detail.title">{{ isAdmin ? detail.distributor_code + ': ' : '' }} {{ detail.title }}</span>
        </h1>

        <div class="filters" v-if="!filters.push_pack_id">
            <div class="two-columns selectors">
                <label>Description</label>
                <label></label>
                <div class="input-with-control">
                    <input class="promotions" type="search" v-model="filters.search_text" placeholder="Search..." @search="setFilter('search_text')">
                    <div class="button promotions input-go" @click="setFilter('search_text')"><i class="fas fa-search"></i></div>
                </div>
            </div>
        </div>

        <div v-if="message" class="empty-list">
            {{ message }}
            <div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>

        <div v-if="!loading && !push_pack_id && campaignReports.length > 0" class="item-list">
            <div v-for="(campaignReport, index) in campaignReports" :key="index" :class="['item-row', { isadmin: isAdmin }]" @click="loadItem(campaignReport.push_pack_id)">
                <div>
                    <img v-if="campaignReport.image_src" :src="campaignReport.image_src" />
                </div>
                <div>
                    <label>Description</label>
                    <p>{{ campaignReport.title }}</p>
                    <label>Code</label>
                    <p>{{ campaignReport.push_pack_code }}</p>
                    <label v-if="isAdmin">Distributor</label>
                    <p v-if="isAdmin">{{ campaignReport.distributor_code}}</p>
                    <label>Sent Date</label>
                    <p>{{ campaignReport.schedule_date }}</p>
                </div>
                <div>
                    <label>Emails Sent</label>
                    <p>{{ campaignReport.sent }}</p>
                    <label>Total Opens</label>
                    <p>{{ campaignReport.opened }}</p>
                    <label>Total Clicks</label>
                    <p>{{ campaignReport.clicked }}</p>
                </div>
                <div>
                    <label>Open Rate</label>
                    <p>{{ campaignReport.open_rate }}</p>
                    <label>Click Rate</label>
                    <p>{{ campaignReport.click_rate }}</p>
                </div>
            </div>
        </div>

        <pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>

        <div v-if="!loading && push_pack_id">
            <div class="main-form">
                <div>
                    <div class="six-columns">
                        <div>
                            <label>Order Date</label>
                            <p>{{ detail.order_start_date }}</p>
                            <label>End Date</label>
                            <p>{{ detail.order_end_date }}</p>
                        </div>
                        <div>
                            <label>Publish Date</label>
                            <p>{{ detail.start_date }}</p>
                            <label>End Date</label>
                            <p>{{ detail.end_date }}</p>
                            <label>Sent Date</label>
                            <p>{{ detail.schedule_date }}</p>
                        </div>
                        <div>
                            <label>Emails Sent</label>
                            <p>{{ detail.totals.sent }}</p>
                            <label>Total Opens</label>
                            <p>{{ detail.totals.opened }}</p>
                            <label>Total Clicks</label>
                            <p>{{ detail.totals.clicked }}</p>
                        </div>
                        <div>
                            <label>Open Rate</label>
                            <p>{{ detail.totals.open_rate }}</p>
                            <label>Click Rate</label>
                            <p>{{ detail.totals.click_rate }}</p>
                        </div>
                        <div>
                            <label>Distributor Qty</label>
                            <p>{{ detail.totals.quantity }}</p>
                            <label>Distributor Retail</label>
                            <p>{{ formatCurrency(detail.totals.order_price) }}</p>
                        </div>
                        <div>
                            <label>Total Qty</label>
                            <p>{{ detail.totals.total_quantity }}</p>
                            <label>Total Retail</label>
                            <p>{{ formatCurrency(detail.totals.total_order_price) }}</p>
                        </div>
                    </div>
                    <div class="report-section">
                        <h2>Products</h2>
                        <div v-for="(product, index) in detail.products" class="product-list">
                            <div class="center"><img :src="product.image_src" /></div>
                            <div>
                                <label>Item</label> {{ product.item_number }}<br>
                                <label>UPC</label> {{ product.upc }}
                            </div>
                            <div>{{ product.description }}</div>
                            <div class="right">
                                <div class="two-columns">
                                    <label>Clicks</label><span>{{ product.clicks }}</span>
                                    <label>Avg Price</label><span>{{ product.price_each > 0 ? formatCurrency(product.price_each) : '' }}</span>
                                </div>
                            </div>
                            <div class="right">
                                <div class="two-one-columns">
                                    <label>Dist Qty</label><span>{{ product.quantity }}</span>
                                    <label>Dist Retail</label><span>{{ product.quantity > 0 ? formatCurrency(product.order_price) : '' }}</span>
                                </div>
                            </div>
                            <div class="right">
                                <div class="two-one-columns">
                                    <label>Total Qty</label><span>{{ product.total_quantity }}</span>
                                    <label>Total Retail</label><span>{{ product.total_quantity > 0 ? formatCurrency(product.total_order_price) : '' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="report-section">
                        <h2>Marquees</h2>
                        <div v-for="(marquee, index) in detail.marquees" class="marquee-list">
                            <div class="center"><img :src="marquee.image_src" /></div>
                            <div>
                                <label>Item</label> {{ marquee.item_number }}<br>
                                <label>UPC</label> {{ marquee.upc }}
                            </div>
                            <div>{{ marquee.description }}</div>
                            <div class="right">
                                <div class="two-columns">
                                    <label>Clicks</label><span>{{ marquee.clicks }}</span>
                                    <label>Avg Price</label><span>{{ marquee.price_each }}</span>
                                </div>
                            </div>
                            <div class="right">
                                <div class="two-columns">
                                    <label>Dist Qty</label><span>{{ marquee.quantity }}</span>
                                    <label>Dist Retail</label><span>{{ marquee.quantity > 0 ? formatCurrency(marquee.order_price) : '' }}</span>
                                </div>
                            </div>
                            <div class="right">
                                <div class="two-one-columns">
                                    <label>Total Qty</label><span>{{ marquee.total_quantity }}</span>
                                    <label>Total Retail</label><span>{{ marquee.total_quantity > 0 ? formatCurrency(marquee.total_order_price) : '' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <img v-if="detail.image_src" :src="detail.image_src" style="max-width: 20em;" />
                    </div>
                    <div v-if="isAdmin" style="margin: 1em 0;">
                        <div v-if="detail.totals.report_time" style="margin: 1em 0;">
                            <label>Last Update</label>
                            {{ detail.totals.report_time }}
                        </div>
                        <div :class="['button', schedulingUpdate ? 'disabled' : 'promotions']" @click="scheduleUpdate()">Schedule Report Update</div>
                        <label v-if="scheduleUpdateMessage">{{ scheduleUpdateMessage }}</label>
                    </div>
                </div>
            </div>
        </div>

	</section>

</template>

<script>
export default {
	name: 'promotions',
    props: ['push_pack_id'],
	data() {
        return {
            loading: true,
            message: '',
            filters: {
                section: 'campaigns',
                page: 1,
                search_text: '',
                push_pack_id: '',
                start_date: this.getTodaysDate(),
                end_date: this.getTodaysDate()
            },
            paging: {},
            campaignReports: [],
            detail: {},
            schedulingUpdate: false,
            scheduleUpdateMessage: ''
        }
    },
    created() {
        // any filters previously stored for this section?
        if (this.getFilters.section == 'campaigns') {
            this.filters = this.getFilters // filters were stored last time we hit fetchDataItems()
        }
        if (this.push_pack_id) {
            this.filters.push_pack_id = this.push_pack_id
            this.fetchDetail()
        } else {
            this.filters.push_pack_id = ''
            this.fetchList()
        }
    },
    computed: {
        pageSection() {
            if (this.$route.query.section) {
                return this.capitalizeFirstLetter(this.$route.query.section)
            } else {
                return 'Campaign'
            }
        },
        showPagination() {
            return this.campaignReports.length > 0 && this.paging.total_pages > 1
        },
        isAdmin() {
            return this.getUser.user_type_code.indexOf('ADMIN') > -1
        },
    },
    methods: {
        fetchList() {
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_list_campaign_reports', data: this.filters }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.storeFilters(this.filters) // store current filter set
                    this.message = ''
                    this.paging = obj.paging
                    this.campaignReports = obj.campaign_reports
                } else {
                    this.message = obj.message
                }
            })
        },
        goToPage(page) {
			this.paging.current_page = page
			this.setFilter('page')
		},
        setFilter(which) {
            switch (which) {
                case 'page':
                    this.filters.page = this.paging.current_page
                    this.fetchList()
                    return false;
                case 'search_text':
                    this.fetchList()
                    return false
                case 'dates':
                    this.fetchList()
                    return false
            }
        },
        clearFilters() {
            this.filters = {
                section: 'promotions',
                page: 1,
                push_pack_id: '',
                search_text: '',
                start_date: this.getYearStartDate(),
                end_date: this.getTodaysDate()
            }
            this.detail = {}
            this.push_pack_name = ''
            this.message = ''
            if (this.$route.path != '/campaignreports') {
                // pushing route will clear id
                this.$router.push('/campaignreports')
            } else {
                // but if base route already, reload data
                this.fetchList()
            }
        },
        loadItem(pushPackId) {
            this.$router.push('/campaignreports/' + pushPackId)
        },
        fetchDetail() {
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_item_campaign_report', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                this.loading = false
                this.message = obj.message
                if (obj.status == 'success') {
                    this.detail = obj.detail
                }
            })
        },
        scheduleUpdate() {
            if (this.schedulingUpdate) { return }
            this.schedulingUpdate = true
            this.scheduleUpdateMessage = ''
            this.apiCall({ destination: 'schedule_campaing_update', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                this.schedulingUpdate = false
                this.scheduleUpdateMessage = obj.message
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.item-row, .item-row-heading {
    grid-template-columns: 1fr 1.5fr 1fr 1fr;
    grid-column-gap: 2em;
    .center { text-align: center; }
    img { max-width: 100%; }
    p { margin: 0 0 0.25em 0; }
}
.main-form {
    grid-template-columns: 2fr 20em;
    grid-gap: 3em;
    p { margin: 0 0 0.25em 0; }
    .report-section {
        h2 {
            border-bottom: 1px dotted #999; margin: 1em 0 0 0;
        }
        .product-list, .marquee-list {
            display: grid;
            grid-template-columns: 5em 1fr 2fr 10em 1fr 1fr;
            grid-column-gap: 1em;
            align-items: center;
            padding: 0.5em 0;
            border-bottom: 1px dotted #999;
            img { max-height: 3em; max-width: 90%; }
            .center { text-align: center; }
            .right { text-align: right; }
        }
    }
}
</style>
